export const environment = {
  production: false,
  apiBaseUrl: 'https://staging.api.groupwisdom.tech/v1/',
  // apiBaseUrlV2: 'https://staging.api.groupwisdom.tech/v2/',
  frontendBaseUrlWithWww: 'https://staging.participant.groupwisdom.tech/',
  frontendBaseUrlWithoutWww: 'https://staging.participant.groupwisdom.tech/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts